import React, { useEffect, useState, useRef } from "react";
import { Link, useParams } from "react-router-dom";

function NewUIAccountDetailDropdown({ name, userType, handleLogout }) {
  const [loginDetails, setLoginDetails] = useState(false);
  const userName = localStorage.getItem("userName");
  const handleOnClickLogIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoginDetails(!loginDetails);
  };
  const accountDetailsRef = useRef(null);
  const accountLoginRef = useRef(null);
  const { id } = useParams();

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  // console.log(userDetails);

  // Function to handle clicks outside the account details div
  const handleClickOutside = (event) => {
    //   if (accountDetailsRef.current && !accountDetailsRef.current.contains(event.target)) {
    //     setAccountDetails(false);
    //   }
    if (
      accountLoginRef.current &&
      !accountLoginRef.current.contains(event.target)
    ) {
      setLoginDetails(false);
    }
  };

  useEffect(() => {
    // Attach the click event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup the event listener on component unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div
      onClick={handleOnClickLogIn}
      className="new_ui_login_btn"
      // style={{ position: "relative", top: "0", right: "0" }}
      ref={accountLoginRef}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_5983_6845"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5983_6845)">
          <path
            d="M5.01909 14.4101C5.72742 13.8846 6.49909 13.4695 7.33409 13.1649C8.16895 12.8605 9.05756 12.7083 9.99992 12.7083C10.9423 12.7083 11.8309 12.8605 12.6658 13.1649C13.5008 13.4695 14.2724 13.8846 14.9808 14.4101C15.4988 13.8407 15.9093 13.1815 16.2122 12.4326C16.5151 11.6837 16.6666 10.8728 16.6666 9.99992C16.6666 8.1527 16.0173 6.57978 14.7187 5.28117C13.4201 3.98256 11.8471 3.33325 9.99992 3.33325C8.1527 3.33325 6.57978 3.98256 5.28117 5.28117C3.98256 6.57978 3.33325 8.1527 3.33325 9.99992C3.33325 10.8728 3.48471 11.6837 3.78763 12.4326C4.09054 13.1815 4.50103 13.8407 5.01909 14.4101ZM9.99992 10.6249C9.23922 10.6249 8.5977 10.3637 8.07534 9.84117C7.55283 9.31881 7.29158 8.67728 7.29158 7.91658C7.29158 7.15589 7.55283 6.51436 8.07534 5.992C8.5977 5.4695 9.23922 5.20825 9.99992 5.20825C10.7606 5.20825 11.4021 5.4695 11.9245 5.992C12.447 6.51436 12.7083 7.15589 12.7083 7.91658C12.7083 8.67728 12.447 9.31881 11.9245 9.84117C11.4021 10.3637 10.7606 10.6249 9.99992 10.6249ZM9.99992 17.9166C8.90061 17.9166 7.86936 17.7098 6.90617 17.2964C5.94297 16.8829 5.10513 16.3198 4.39263 15.6072C3.67999 14.8947 3.11693 14.0569 2.70346 13.0937C2.28999 12.1305 2.08325 11.0992 2.08325 9.99992C2.08325 8.90061 2.28999 7.86936 2.70346 6.90617C3.11693 5.94297 3.67999 5.10513 4.39263 4.39263C5.10513 3.67999 5.94297 3.11693 6.90617 2.70346C7.86936 2.28999 8.90061 2.08325 9.99992 2.08325C11.0992 2.08325 12.1305 2.28999 13.0937 2.70346C14.0569 3.11693 14.8947 3.67999 15.6072 4.39263C16.3198 5.10513 16.8829 5.94297 17.2964 6.90617C17.7098 7.86936 17.9166 8.90061 17.9166 9.99992C17.9166 11.0992 17.7098 12.1305 17.2964 13.0937C16.8829 14.0569 16.3198 14.8947 15.6072 15.6072C14.8947 16.3198 14.0569 16.8829 13.0937 17.2964C12.1305 17.7098 11.0992 17.9166 9.99992 17.9166Z"
            fill=""
          />
        </g>
      </svg>
      <button className="Header-logbtn Login-text-hide text-capitalize">
        Hi, {userDetails?.name ? userDetails?.name : userName || "User"}{" "}
      </button>{" "}
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          transform: loginDetails ? "rotate(180deg)" : "rotate(0deg)",
          transition: "transform 0.2s ease-in-out",
        }}
      >
        <mask
          id="mask0_5983_6849"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="14"
          height="14"
        >
          <rect
            y="14"
            width="14"
            height="14"
            transform="rotate(-90 0 14)"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_5983_6849)">
          <path
            d="M6.99982 8.64202L11.3939 4.24791C11.5098 4.13202 11.6463 4.07554 11.8033 4.07845C11.9604 4.08147 12.0969 4.14092 12.2128 4.25681C12.3287 4.37279 12.3866 4.50929 12.3866 4.66631C12.3866 4.82332 12.3287 4.95982 12.2128 5.07581L7.74693 9.55056C7.64144 9.65604 7.52327 9.73421 7.39241 9.78506C7.26155 9.8359 7.13069 9.86133 6.99983 9.86133C6.86896 9.86133 6.7381 9.8359 6.60724 9.78506C6.47638 9.73421 6.35821 9.65604 6.25272 9.55056L1.77783 5.07581C1.66194 4.95982 1.6055 4.82181 1.60851 4.66179C1.61153 4.50176 1.67098 4.3638 1.78687 4.24791C1.90276 4.13202 2.03926 4.07408 2.19637 4.07408C2.35338 4.07408 2.48983 4.13202 2.60572 4.24791L6.99982 8.64202Z"
            fill=""
          />
        </g>
      </svg>
      {loginDetails && (
        <div className="accountDetails" ref={accountDetailsRef}>
          {userType === "customer" ? (
            <>
              {/* <div className="accountDropdown_main">
                <Link
                  className=" flex_align_center flex_gap_10"
                  to="/customer-account?role=profile"
                >
                  <span className="AccountDetails_dropdown">
                    <svg
                      className="m_0"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.04551 6.54502C6.14832 6.54502 5.38027 6.22557 4.74137 5.58666C4.10246 4.94775 3.78301 4.17971 3.78301 3.28252C3.78301 2.38533 4.10246 1.61729 4.74137 0.978379C5.38027 0.339473 6.14832 0.0200195 7.04551 0.0200195C7.94269 0.0200195 8.71074 0.339473 9.34965 0.978379C9.98855 1.61729 10.308 2.38533 10.308 3.28252C10.308 4.17971 9.98855 4.94775 9.34965 5.58666C8.71074 6.22557 7.94269 6.54502 7.04551 6.54502ZM0.520508 11.4388V10.7863C0.520508 10.3241 0.639453 9.89928 0.877344 9.51186C1.11523 9.12443 1.43129 8.82877 1.82551 8.62486C2.66832 8.20346 3.52473 7.8874 4.39473 7.6767C5.26473 7.466 6.14832 7.36064 7.04551 7.36064C7.94269 7.36064 8.82629 7.466 9.69629 7.6767C10.5663 7.8874 11.4227 8.20346 12.2655 8.62486C12.6597 8.82877 12.9758 9.12443 13.2137 9.51186C13.4516 9.89928 13.5705 10.3241 13.5705 10.7863V11.4388C13.5705 11.8874 13.4108 12.2714 13.0913 12.5908C12.7719 12.9103 12.3879 13.07 11.9393 13.07H2.15176C1.70316 13.07 1.31914 12.9103 0.999687 12.5908C0.680234 12.2714 0.520508 11.8874 0.520508 11.4388ZM2.15176 11.4388H11.9393V10.7863C11.9393 10.6367 11.9019 10.5008 11.8271 10.3785C11.7523 10.2561 11.6538 10.161 11.5314 10.093C10.7974 9.72596 10.0565 9.45068 9.30887 9.26717C8.56121 9.08365 7.80676 8.99189 7.04551 8.99189C6.28426 8.99189 5.5298 9.08365 4.78215 9.26717C4.03449 9.45068 3.29363 9.72596 2.55957 10.093C2.43723 10.161 2.33867 10.2561 2.26391 10.3785C2.18914 10.5008 2.15176 10.6367 2.15176 10.7863V11.4388ZM7.04551 4.91377C7.4941 4.91377 7.87812 4.75404 8.19758 4.43459C8.51703 4.11514 8.67676 3.73111 8.67676 3.28252C8.67676 2.83393 8.51703 2.4499 8.19758 2.13045C7.87812 1.811 7.4941 1.65127 7.04551 1.65127C6.59691 1.65127 6.21289 1.811 5.89344 2.13045C5.57398 2.4499 5.41426 2.83393 5.41426 3.28252C5.41426 3.73111 5.57398 4.11514 5.89344 4.43459C6.21289 4.75404 6.59691 4.91377 7.04551 4.91377Z"
                        fill="#000"
                      />
                    </svg>
                  </span>
                  <span className="text-left">
                    <strong>My Account</strong> <br />
                    <small style={{ color: "#016937" }}>
                      Manage your Account
                    </small>
                  </span>
                </Link>
              </div> */}
              <div className="accountDropdown_main">
                <Link
                  className=" flex_align_center flex_gap_10"
                  to="/customer-profile"
                >
                  <span className="AccountDetails_dropdown">
                    <svg
                      className="m_0"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_3887_4171"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      >
                        <rect width="24" height="24" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_3887_4171)">
                        <path
                          d="M10.95 18.35L7.4 14.8L8.85 13.35L10.95 15.45L15.15 11.25L16.6 12.7L10.95 18.35ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8Z"
                          fill="#1C1B1F"
                        />
                      </g>
                    </svg>
                  </span>
                  <span className="text-left">
                    <strong>My Profile</strong> <br />{" "}
                    <small style={{ color: "#016937" }}>
                      Manage your Account
                    </small>
                  </span>
                </Link>
              </div>
              {/* <div className="accountDropdown_main">
                <Link
                  className=" flex_align_center flex_gap_10"
                  to="/customer-account?role=bookings"
                >
                  <span className="AccountDetails_dropdown">
                    <svg
                      className="m_0"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_3887_4171"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      >
                        <rect width="24" height="24" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_3887_4171)">
                        <path
                          d="M10.95 18.35L7.4 14.8L8.85 13.35L10.95 15.45L15.15 11.25L16.6 12.7L10.95 18.35ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8Z"
                          fill="#1C1B1F"
                        />
                      </g>
                    </svg>
                  </span>
                  <span className="text-left">
                    <strong>My Booking </strong> <br />{" "}
                    <small style={{ color: "#016937" }}>
                      Manage your Bookings
                    </small>
                  </span>
                </Link>
              </div> */}
            </>
          ) : userType === "agent" ? (
            <>
              <div className="accountDropdown_main">
                <Link
                  className="flex_align_center flex_gap_10"
                  to="/agent-dashboard"
                >
                  <span className="AccountDetails_dropdown">
                    <svg
                      className="m_0"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_3887_4171"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      >
                        <rect width="24" height="24" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_3887_4171)">
                        <path
                          d="M10.95 18.35L7.4 14.8L8.85 13.35L10.95 15.45L15.15 11.25L16.6 12.7L10.95 18.35ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8Z"
                          fill="#1C1B1F"
                        />
                      </g>
                    </svg>
                  </span>

                  <span style={{ textAlign: "left" }}>
                    <strong style={{ color: "black" }}>My Dashboard</strong>
                    <br />{" "}
                    <small style={{ color: "#016937" }}>
                      Manage your Account
                    </small>
                  </span>
                </Link>
              </div>
            </>
          ) : (
            <>
              {" "}
              <div className="accountDropdown_main">
                <Link
                  className="flex_align_center flex_gap_10"
                  to={`/vendor/property/list`}
                >
                  <span className="AccountDetails_dropdown">
                    <svg
                      className="m_0"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_3887_4171"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      >
                        <rect width="24" height="24" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_3887_4171)">
                        <path
                          d="M10.95 18.35L7.4 14.8L8.85 13.35L10.95 15.45L15.15 11.25L16.6 12.7L10.95 18.35ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8Z"
                          fill="#1C1B1F"
                        />
                      </g>
                    </svg>
                  </span>

                  <span style={{ textAlign: "left" }}>
                    <strong style={{ color: "black" }}>My Dashboard</strong>
                    <br />{" "}
                    <small style={{ color: "#016937" }}>
                      Manage your Account
                    </small>
                  </span>
                </Link>
              </div>
            </>
          )}
          <div
            className="w-full flex_align_center flex_gap_10"
            to=""
            style={{ padding: "0 10px", cursor: "pointer",margin:"7px 0" }}
            onClick={handleLogout}
          >
            <span className="AccountDetails_dropdown">
              <svg
                className="m_0"
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.75 14.25C1.3375 14.25 0.984375 14.1031 0.690625 13.8094C0.396875 13.5156 0.25 13.1625 0.25 12.75V2.25C0.25 1.8375 0.396875 1.48438 0.690625 1.19063C0.984375 0.896875 1.3375 0.75 1.75 0.75H7V2.25H1.75V12.75H7V14.25H1.75ZM10 11.25L8.96875 10.1625L10.8813 8.25H4.75V6.75H10.8813L8.96875 4.8375L10 3.75L13.75 7.5L10 11.25Z"
                  fill="#000"
                />
              </svg>
            </span>
            <div>
              <strong style={{ color: "black" }}>Log Out</strong>
            </div>
          </div>{" "}
        </div>
      )}
    </div>
  );
}

export default NewUIAccountDetailDropdown;
